import React from 'react'
import './Plan.css'

const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
}

const plans = [
    { speed: '10 MBPS',  prices: [412,  1058, 1763, 2999] },
    { speed: '30 MBPS',  prices: [471,  1235, 2117, 3599] },
    { speed: '50 MBPS',  prices: [707,  1943, 3533, 5999] },
    { speed: '100 MBPS', prices: [825,  2297, 4241, 7774] },
    { speed: '300 MBPS', prices: [1200, 2999, 4999, 8999] },
]

const durations = ['30 DAYS', '90 DAYS', '180 DAYS', '360 DAYS']

const Plan = () => {
    return (
        <div name='Plan' className='plan'>
            <div className="plan-container">

                {/* Tagline Banner */}
                <div className="plan-tagline reveal">
                    <p className="plan-tagline-top">
                        350+ LIVE TV CHANNELS &amp; 22+ OTT APPS <span className="plan-free">FREE</span>
                    </p>
                    <p className="plan-tagline-bottom">
                        INTERNET SERVICE <span className="plan-unlimited">UNLIMITED</span> PLANS
                    </p>
                </div>

                {/* Pricing Table */}
                <div className="plan-table-wrapper reveal">
                    <table className="plan-table">
                        <thead>
                            <tr>
                                <th className="plan-th plan-th-packages">PACKAGES</th>
                                {durations.map(d => (
                                    <th key={d} className="plan-th plan-th-duration">{d}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {plans.map((plan, i) => (
                                <tr key={plan.speed} className="plan-row">
                                    <td className="plan-td plan-td-speed">
                                        <span className="plan-speed-badge">{plan.speed}</span>
                                    </td>
                                    {plan.prices.map((price, j) => (
                                        <td key={j} className="plan-td plan-td-price">
                                            &#8377;{price}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Notes */}
                <div className="plan-notes">
                    <p className="plan-note-install">
                        INSTALLATION CHARGES <span className="plan-highlight">500 RS</span> FOR <span className="plan-highlight">MONTHLY PLANS!</span>
                    </p>
                    <p className="plan-note-deposit">
                        FOR FIBER OPTIC CONNECTION ONE-TIME SECURITY DEPOSIT 500 RS
                    </p>
                </div>

                {/* More Plans CTA */}
                <div className="plan-cta">
                    <a
                        href='/'
                        className='button plan-btn'
                        onClick={(e) => { e.preventDefault(); openInNewTab('https://drive.google.com/file/d/1FClmgTdU_udzD1JCdi1ECcN0kF8esmpW/view') }}
                    >
                        More Plans
                    </a>
                </div>

            </div>
        </div>
    )
}

export default Plan
